module.exports = __webpack_public_path__ + "img/form-o-1.cc85d18e.svg";